import Individual from "./individual/individual_list.store";

export default {
  modules: { Individual },
};
